const colors = ['#00CEFF', '#64E633', '#839AA7', '#FF6692', '#9A85C2', '#E2D46B', '#43DE77', '#21D6BB', '#CB9172', '#F97C8A', '#11D2DD', '#EEA87A', '#CB74DE', '#7ED143', '#8F90B4', '#E8BE73', '#F39282', '#E57B82', '#D5BB94', '#CF8BC6', '#53E255', '#C85CF7', '#98BB53', '#B171DC', '#D2A3AD', '#D9D27C', '#B2A662', '#BD66EA', '#DCEA63', '#32DA99', '#A67BCF']

export default colors
